import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const PizzaParty = () => {
  const canvasRef = useRef(null);
  const [totalSlices, setTotalSlices] = useState(0);
  const [halfInput, setHalfInput] = useState('');
  const [quarterInput, setQuarterInput] = useState('');
  const [whoInput, setWhoInput] = useState('');
  const [result, setResult] = useState('');

  const correctSound = useRef(new Audio("https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg"));
  const wrongSound = useRef(new Audio("https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg"));
  const cheerSound = useRef(new Audio("https://actions.google.com/sounds/v1/ambiences/crowd_cheer.ogg"));

  const drawPizza = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const slices = [4, 8, 12,6,30,10,24,16,18][Math.floor(Math.random() * 8)];
    setTotalSlices(slices);
    const angle = (2 * Math.PI) / slices;
    const radius = 120;
    const cx = 150, cy = 150;

    for (let i = 0; i < slices; i++) {
      ctx.beginPath(); 
      ctx.moveTo(cx, cy);
      ctx.arc(cx, cy, radius, i * angle, (i + 1) * angle);
      ctx.closePath();
      ctx.fillStyle = '#fff3e0';
      ctx.fill();
      ctx.stroke();
    }

    setTimeout(() => colorSlices(ctx, slices / 2, '#ff7043', '🐵', slices), 300);
    setTimeout(() => colorSlices(ctx, slices / 4, '#ffccbc', '🐰', slices), 1000);
  };

  const colorSlices = (ctx, count, color, emoji, total) => {
    const angle = (2 * Math.PI) / total;
    const radius = 120;
    const cx = 150, cy = 150;
    for (let i = 0; i < count; i++) {
      setTimeout(() => {
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.arc(cx, cy, radius, i * angle, (i + 1) * angle);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
        ctx.stroke();

        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate((i + 0.5) * angle);
        ctx.fillStyle = 'black';
        ctx.font = '16px Comic Sans MS';
        ctx.fillText(emoji, radius / 2, 5);
        ctx.restore();
      }, i * 100);
    }
  };

  const checkAnswers = () => {
    const halfCorrect = parseInt(halfInput, 10) === totalSlices / 2;
    // const quarterCorrect = parseInt(quarterInput, 10) === math.floor( totalSlices / 4);
    const quarterCorrect = parseInt(quarterInput, 10) === Math.floor(totalSlices / 4);

    const whoCorrect = whoInput.trim().toLowerCase() === 'monkey';
    let allCorrect = true;
    const messages = [];

    if (halfCorrect) {
      messages.push("✅ Monkey half is correct!");
      correctSound.current.play();
    } else {
      messages.push("❌ Monkey half is incorrect.");
      wrongSound.current.play();
      allCorrect = false;
    }

    if (quarterCorrect) {
      messages.push("✅ Bunny quarter is correct!");
      correctSound.current.play();
    } else {
      messages.push("❌ Bunny quarter is incorrect.");
      wrongSound.current.play();
      allCorrect = false;
    }

    // if (whoCorrect) {
    //   messages.push("✅ Correct, monkey ate more!");
    //   correctSound.current.play();
    // } else {
    //   messages.push("❌ Incorrect, monkey ate more than dog!");
    //   wrongSound.current.play();
    //   allCorrect = false;
    // }

    setResult(messages.join('\n'));

    if (allCorrect) {
       const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setTimeout(() => {
        cheerSound.current.play();
      }, 300);
    }
  };

  const resetGame = () => {
    setHalfInput('');
    setQuarterInput('');
    setWhoInput('');
    setResult('');
    drawPizza();
  };

  useEffect(() => {
    drawPizza();
  }, []);

  const styles = {
    container: {
      fontFamily: "'Comic Sans MS', cursive",
      background: '#fff8e1',
      textAlign: 'center',
      padding: '2rem 1rem',
      minHeight: '100vh',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    h1: {
      color: '#d84315',
      fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
      marginBottom: '1rem'
    },
    canvas: {
      background: '#ffe0b2',
      borderRadius: '50%',
      border: '2px solid #d84315',
      boxShadow: '0 0 10px rgba(0,0,0,0.2)',
      maxWidth: '90vw',
      width: 'min(300px, 90vw)',
      height: 'min(300px, 90vw)'
    },
    question: {
      fontSize: 'clamp(1rem, 2.5vw, 1.3rem)',
      margin: '1.2rem auto',
      maxWidth: '400px',
      width: '100%'
    },
    input: {
      fontSize: '1rem',
      padding: '8px 12px',
      borderRadius: 6,
      border: '2px solid #f9a825',
      textAlign: 'center',
      display: 'block',
      margin: '10px auto',
      width: '80%',
      maxWidth: '200px'
    },
    button: {
      padding: '12px 24px',
      fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
      background: '#ff7043',
      border: 'none',
      color: 'white',
      borderRadius: '8px',
      cursor: 'pointer',
      margin: '10px'
    },
    result: {
      marginTop: '20px',
      fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
      fontWeight: 'bold',
      whiteSpace: 'pre-line',
      maxWidth: '90vw'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>🍕 Pizza Party!</h1>
      <canvas ref={canvasRef} width={300} height={300} style={styles.canvas}></canvas>

      <div style={styles.question}>How many slices? <b>{totalSlices}</b></div>

      <div style={styles.question}>
        🐵 eats HALF — how many slices is that?
        <input style={styles.input} value={halfInput} onChange={e => setHalfInput(e.target.value)} />
      </div>

      <div style={styles.question}>
        🐰 eats ONE-QUARTER — how many slices is that?
        <input style={styles.input} value={quarterInput} onChange={e => setQuarterInput(e.target.value)} />
      </div>

      {/* <div style={styles.question}>
        Who ate more? (🐵 = 50% | 🐶 = 25%)
        <input style={styles.input} value={whoInput} onChange={e => setWhoInput(e.target.value)} />
      </div> */}

      <button style={styles.button} onClick={checkAnswers}>✅ Check Answers</button>
      <button style={styles.button} onClick={resetGame}>🔁 New Pizza</button>

      <div id="result" style={styles.result}>{result}</div>
    </div>
  );
};

export default PizzaParty;
